import { Card } from "@mui/material";
import { sxStyles } from "./central-container.styles";

export const CentralContainer = ({ children, width = 700 }) => {
    return <Card sx={{ ...sxStyles.container, width: width }}>{children}</Card>;
};
